import React from 'react';
import useFilterModalContext from '../../useFilterModalContext';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';
import useCondition from '../../../useCondition';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {condition, setCondition} = useCondition();
  const options = [
    {label: '配信', value: false},
    {label: '配信停止', value: true},
  ];

  if (condition?.isUnsubscribed === null) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">配信停止</h4>
        <button
          onClick={() => setFilterType('isUnsubscribed')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() => setCondition({isUnsubscribed: null})}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex gap-1">
        {options.map(
          (option) =>
            condition.isUnsubscribed === option.value && (
              <span
                key={option.label}
                className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
                {option.label}
              </span>
            ),
        )}
      </div>
    </div>
  );
};
